import {
  ChronoUnit,
  DateTimeFormatter,
  Duration,
  LocalDate,
  LocalDateTime,
  LocalTime,
} from "@js-joda/core";
import { parseDayOfWeek } from "../MessageRevivers";
import { DayOfWeek } from "../messages/JSJodaJSON";
import { STRINGS } from "../strings";
import { globalize, translate } from "../translate";

export function isOvernight(startDateTime: LocalDateTime, endDateTime: LocalDateTime) {
  return startDateTime
    .truncatedTo(ChronoUnit.DAYS)
    .isBefore(endDateTime.truncatedTo(ChronoUnit.DAYS));
}

export function formatDuration(negDuration: Duration, defaultEmptyDuration?: string): string {
  const duration = negDuration.isNegative() ? negDuration.plusDays(1) : negDuration;
  const hours = duration.toHours();
  const minutes = duration.minusHours(hours).toMinutes();
  const strs: string[] = [];

  if (hours > 0) {
    strs.push(globalize().formatUnit(hours, "hour", { form: "long" }));
  }
  if (minutes > 0) {
    strs.push(globalize().formatUnit(minutes, "minute", { form: "long" }));
  }
  if (strs.length === 0) {
    return defaultEmptyDuration ?? translate(STRINGS.EMPTY_DURATION);
  }
  return strs.join(" ");
}

export function formatTime(value: LocalTime) {
  return globalize().formatLocalTime(value, { time: "short" });
}

export function formatTimes(times: { startAt: LocalTime; endAt: LocalTime }) {
  return `${formatTime(times.startAt)} - ${formatTime(times.endAt)}`;
}

export function formatDayOfWeek(dayOfWeek: DayOfWeek | string, short = false) {
  const day = typeof dayOfWeek === "string" ? parseDayOfWeek(dayOfWeek) : dayOfWeek;
  return globalize().formatDayOfWeek(day, short);
}

export function formatDate(value: LocalDate, pattern = "MM/dd/yyyy") {
  return value.format(DateTimeFormatter.ofPattern(pattern));
}

export function formatDates(startDate: LocalDate, endDate: LocalDate, pattern?: string) {
  return `${formatDate(startDate, pattern)} — ${formatDate(endDate, pattern)}`;
}

export function formatDateTime(value: LocalDateTime) {
  const localDate = value.toLocalDate();
  const localTime = value.toLocalTime();

  return `${formatDate(localDate)} ${formatTime(localTime)}`;
}

export function formatDayOfWeekAndTimeShort(dayOfWeek: DayOfWeek, time: LocalTime) {
  return `${formatDayOfWeek(dayOfWeek, true)} ${formatTime(time)}`;
}

export function localDateMax(date1: LocalDate, date2: LocalDate): LocalDate {
  return date1.isAfter(date2) ? date1 : date2;
}
